/**
 * Hive Flow — GENERIC operator run-surface route: ``/workspace/flows/$flowId/run``.
 *
 * The active run rides the URL as ``?focus=<runId>`` (the shared workspace
 * detail-surface contract — inline + URL-addressable, no drawer). The route is
 * intentionally UN-NESTED from the visual editor (``flows.$flowId.tsx``) via
 * the trailing-underscore segment (``$flowId_``): the editor route renders no
 * ``<Outlet/>``, so nesting under it would make this a dead route. The
 * underscore keeps the URL (``/flows/$flowId/run``) + the ``flowId`` param
 * while re-parenting the render under the ``flows`` layout (which DOES
 * ``<Outlet/>``), exactly as the task's "under the flows layout" intent asks.
 */

import { createFileRoute } from "@tanstack/react-router";
import type * as React from "react";

import { FlowRunSurface } from "@/features/hive-flows/run/FlowRunSurface";
import { validateWorkspaceSearch } from "@/features/workspace-router";

export const Route = createFileRoute("/_authed/workspace/flows/$flowId_/run")({
  validateSearch: validateWorkspaceSearch,
  component: FlowRunRoute,
});

function FlowRunRoute(): React.JSX.Element {
  const { flowId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <FlowRunSurface
      flowId={flowId}
      focusRunId={search.focus}
      onFocusRun={(runId) => {
        void navigate({ search: (prev) => ({ ...prev, focus: runId }) });
      }}
      onClearFocus={() => {
        void navigate({ search: (prev) => ({ ...prev, focus: undefined }) });
      }}
    />
  );
}
